<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { proxy } = getCurrentInstance();

const page = ref(1)
const perPage = ref(15)
const list = computed(() => proxy.$store.state.bettingHistory)
const totalCount = computed(() => proxy.$store.state.bettingHistoryTotal)

const getListBetting = async () => {
  await proxy.$store.dispatch('fetchBettingHistory', {
    page: page.value,
    perPage: perPage.value,
  })
}

const handlePageChange = (pageNum) => {
  page.value = pageNum
  getListBetting()
}

onMounted(() => {
  getListBetting()
})
</script>

<template>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">{{ t('betting.name') }}</th>
        <th scope="col">{{ t('betting.game') }}</th>
        <th scope="col">{{ t('betting.type') }}</th>
        <th scope="col">{{ t('betting.amount') }}</th>
        <th scope="col">{{ t('betting.date') }}</th>
      </tr>
    </thead>
    <tbody v-if="list.length > 0">
      <tr v-for="(item, index) in list" :key="index">
        <td>{{ item.provider_name }}</td>
        <td>{{ item.game_name }}</td>
        <td v-if="item.reason == 'WIN'" style="font-weight: 400;">
          <span v-if="item.amount == 0" style="color: orange;">
            {{ item.reason }}
          </span>
          <span v-else style="color: #00FF00;">
            {{ item.reason }}
          </span>
        </td>
        <td v-else-if="item.reason == 'BET'" style="color: #ADB900FF;font-weight: 400;">
          {{ item.reason }}
        </td>
        <td v-else style="color: orange;font-weight: 400;">
          {{ item.reason }}
        </td>
        <td>{{
          new Intl.NumberFormat('en-US', { minimumFractionDigits: 0 })
            .format(Number(item.amount))
        }}</td>
        <td>{{ new Date(item.created_at).toLocaleString() }}</td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td colspan="100" class="text-center">{{ t('common.noData') }}</td>
      </tr>
    </tbody>
  </table>
  <nav class="custom-pagination">
    <paginate 
      @update:modelValue="handlePageChange"
      :total-count="totalCount"
      :limit="perPage"
      v-model="page"
    />
  </nav>
</template>

<style scoped>
.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  text-align: center;
}

.custom-pagination {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}
</style>
